import { Box } from "@mui/material";
import Meta from "components/Meta";
import React from "react";

const LandingPage = () => {
  return (
    <Box maxWidth="580px" margin="120px auto" className="collaborator-info">
      <Meta title="Home" />
      <h2 className="collaborator-h2">Welcome to GROUPOS</h2>
    </Box>
  );
};

export default LandingPage;
